import { Link } from "react-router-dom";

export const ApprovalsCard = ({ pendingLeaves, pendingRegs, departments }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6">
    <h3 className="font-heading font-bold mb-4">Pending approvals</h3>
    <div className="space-y-3">
      <Link to="/admin/leave" data-testid="pending-leaves-link" className="flex items-center justify-between p-3 rounded-lg bg-stone-50 hover:bg-accent transition-colors duration-200">
        <span className="text-sm font-semibold">Leave requests</span>
        <span className="text-sm font-bold text-primary tabular-nums">{pendingLeaves}</span>
      </Link>
      <Link to="/admin/attendance" data-testid="pending-regs-link" className="flex items-center justify-between p-3 rounded-lg bg-stone-50 hover:bg-accent transition-colors duration-200">
        <span className="text-sm font-semibold">Regularizations</span>
        <span className="text-sm font-bold text-primary tabular-nums">{pendingRegs}</span>
      </Link>
    </div>
    <h3 className="font-heading font-bold mt-6 mb-3">Departments</h3>
    <div className="space-y-2">
      {departments.map((x) => (
        <div key={x.department} className="flex justify-between text-sm">
          <span className="text-stone-600">{x.department}</span>
          <span className="font-bold tabular-nums">{x.count}</span>
        </div>
      ))}
    </div>
  </div>
);

export const PendingLeavesCard = ({ leaves }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6">
    <h3 className="font-heading font-bold mb-4">Latest pending leave requests</h3>
    {leaves.length === 0 ? (
      <p className="text-sm text-stone-400">No pending requests. All caught up.</p>
    ) : (
      <div className="divide-y divide-stone-100">
        {leaves.map((r) => (
          <div key={r.id} className="py-3 flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold">{r.employee_name}</div>
              <div className="text-xs text-stone-500">{r.leave_type} · {r.from_date} → {r.to_date} ({r.days}d)</div>
            </div>
            <Link to="/admin/leave" className="text-sm font-bold text-primary" data-testid={`review-leave-${r.id}`}>Review</Link>
          </div>
        ))}
      </div>
    )}
  </div>
);
